import { render, staticRenderFns } from "./ExtraSetting.vue?vue&type=template&id=6063e8d1&scoped=true&"
import script from "./ExtraSetting.vue?vue&type=script&lang=js&"
export * from "./ExtraSetting.vue?vue&type=script&lang=js&"
import style0 from "./ExtraSetting.vue?vue&type=style&index=0&id=6063e8d1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6063e8d1",
  null
  
)

export default component.exports